import NewsletterTwentyNineContainer from "./container/NewsletterTwentyNineContainer";
export default NewsletterTwentyNineContainer;
